import { Controller } from "@hotwired/stimulus"
import {
  trackFilterChange,
  trackCtaClick,
} from "../modules/mypizzeria/ga4_tracker"

export default class extends Controller {
  filterChanged(event) {
    const filterType = event.currentTarget.dataset.filterType
    const filterValue = event.currentTarget.dataset.filterValue
    if (filterType && filterValue) {
      trackFilterChange(filterType, filterValue)
    }
  }

  ctaClicked(event) {
    const ctaType = event.currentTarget.dataset.ctaType
    const ctaLocation = event.currentTarget.dataset.ctaLocation || "leaderboard"
    if (ctaType) {
      trackCtaClick(ctaType, ctaLocation)
    }
  }
}
